/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { CustomerInfoVO } from './CustomerInfoVO';
import { CustomerMessageVO } from './CustomerMessageVO';

export interface GetCustomerResponseVO {
  customer?: CustomerInfoVO;
  error?: CustomerMessageVO;
  originalRequest?: any;
  status?: GetCustomerResponseVO.StatusEnum;
}
export namespace GetCustomerResponseVO {
  export type StatusEnum = 'SUCCESS' | 'FAIL' | 'PARTIAL';
  export const StatusEnum = {
    SUCCESS: 'SUCCESS' as StatusEnum,
    FAIL: 'FAIL' as StatusEnum,
    PARTIAL: 'PARTIAL' as StatusEnum
  };
}
